import publicConfig from "../public-config.js";

import { request as httpRequest } from "./http-library.js";

const ssoHost = publicConfig.external_address;

export const Workflows = {
  read: (query, accessToken, callback) => {
    const requestParams = {
      host: ssoHost,
      path: `/v1/workflows/${query}`,
      method: "GET",
      headers: {
        Authorization: "Bearer " + accessToken,
      },
    };
    httpRequest(
      requestParams,
      (response) => {
        callback(response);
      },
      null,
    );
  },
};
